import styled from 'styled-components';

export const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;
